import {
    useState
} from 'react';
import {
    Container
} from './styled';
import {
    LinkUsersGroup
} from '../LinkUsersGroup'

export function NewGroup({ users, callback }) {

    const [nameGroup, setNameGroup] = useState('');

    return (
        <Container>
            <div>
                <input
                    type="text"
                    name="nameG"
                    id="nameG"
                    value={nameGroup}
                    onChange={(e) => setNameGroup(e.target.value)}
                    placeholder='Nome do Setor'
                />
            </div>
            <div>
                <LinkUsersGroup
                    group={{
                        id: null,
                        name: nameGroup
                    }}
                    usersAll={users}
                    callback={callback}
                />
            </div>
        </Container>
    )
}